import { makeStyles } from '@material-ui/core/styles';
import { LogoMark } from './LogoMark';

const useStyles = makeStyles({
  svg: {
    width: 'auto',
    height: 28,
    overflow: 'visible',
  },
});

/** Sidebar logo, collapsed state: just the animated mark. */
const LogoIcon = () => {
  const classes = useStyles();

  return (
    <svg
      className={classes.svg}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 26.3 27"
      aria-hidden="true"
    >
      <LogoMark />
    </svg>
  );
};

export default LogoIcon;
